import { Link } from 'react-router-dom';
import {
  FileText, FolderKanban, Users, Clock, AlertTriangle,
  ArrowRight, ShieldAlert, Wallet, Receipt, Package,
} from 'lucide-react';
import { KpiCard } from './KpiCard';

const fmt = (v) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 }).format(v || 0);

export function DashboardAdmin({ data }) {
  if (!data) return null;
  return (
    <div className="space-y-6" data-testid="dashboard-admin">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        <KpiCard title="OTs Activas" value={data.ots_ejecucion} icon={Clock} color="text-amber-600" bgColor="bg-amber-50" subtitle={`${data.total_ots} totales`} link="/ordenes-trabajo" />
        <KpiCard title="Proyectos" value={data.proyectos_vigentes} icon={FolderKanban} color="text-blue-600" bgColor="bg-blue-50" subtitle={`${data.total_proyectos} totales`} link="/proyectos" />
        <KpiCard title="Clientes" value={data.total_clientes} icon={Users} color="text-emerald-600" bgColor="bg-emerald-50" link="/clientes" />
        <KpiCard title="Por Pagar" value={fmt(data.monto_por_pagar)} icon={Wallet} color="text-red-600" bgColor="bg-red-50" subtitle={`${data.bills_pendientes} facturas`} />
        <KpiCard title="Urgentes SII" value={data.urgentes_sii} icon={ShieldAlert} color="text-red-600" bgColor="bg-red-50" subtitle={`${data.total_pendientes_ar} pendientes`} link="/contabilidad/acepta-rechazo-dte" urgent={data.urgentes_sii > 0} />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KpiCard title="Recepciones" value={data.total_recepciones} icon={Package} color="text-violet-600" bgColor="bg-violet-50" />
        <KpiCard title="OCs" value={data.ocs_totales} icon={FileText} color="text-cyan-600" bgColor="bg-cyan-50" />
        <KpiCard title="Lotes VB" value={data.lotes_vb_pendientes} icon={Receipt} color="text-orange-600" bgColor="bg-orange-50" subtitle="Pendientes firma" link="/compras/firma-vb-lote" />
        <KpiCard title="Usuarios" value={data.total_usuarios} icon={Users} color="text-gray-600" bgColor="bg-gray-50" />
      </div>
      {data.rechazos_sii_pendientes > 0 && (
        <div className="bg-amber-50 border border-amber-300 rounded-lg p-3 flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0" />
          <span className="text-sm font-medium text-amber-800">{data.rechazos_sii_pendientes} rechazo(s) SII pendientes de confirmar</span>
          <Link to="/contabilidad/acepta-rechazo-dte" className="ml-auto text-sm text-amber-700 hover:underline flex items-center gap-1">Ver <ArrowRight className="w-3.5 h-3.5" /></Link>
        </div>
      )}
    </div>
  );
}
